const seoTextsToggle = {
    'short': `
			<p>
				Підключення до акційного тарифу «IPnet Старт» вартістю 69 грн/міс. можливе тільки для нових абонентів. 
				Акційні умови діють протягом 180 днів з моменту підключення, після закінчення акційного періоду абонент 
				автоматично переводиться на тарифний план «Базовий».
			</p>`,
    'full': `
		<p>
			Підключення до акційного тарифу «IPnet Старт» вартістю 69 грн/міс. можливе тільки для нових абонентів. 
			Акційні умови діють протягом 180 днів з моменту підключення, після закінчення акційного періоду абонент 
			автоматично переводиться на тарифний план «Базовий».
		</p>
		<p>
			Вартість підключення тарифу «IPnet Старт» за умови підписання додаткової угоди на 9 місяців користування 
			складає 99 грн. Всі ціни наведені в гривні з урахуванням ПДВ. Ви можете підключитися до акційного тарифу 
			«IPnet Старт» з 29 листопада 2021 р. до 14 лютого 2022 р.
		</p>`
}
export default seoTextsToggle;